import { useParams } from "react-router-dom";
import { AudioDetails } from "@/app/modules/ContentDetails";

export const Audio = () => {
  const { id } = useParams();
  return <AudioDetails id={parseInt(id ?? "")} />;
};
